<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" modalClass="modal-md" @submit="submit">
        <template #title>
            <template v-if="provider && !readonly">
                {{ i18n('Edit {name}').replace('{name}', i18n('Provider')) }}
            </template>
            <template v-else-if="provider">
                {{ i18n('{name} Detail').replace('{name}', i18n('Provider')) }}
            </template>
            <template v-else>
                {{ i18n('Add {name}').replace('{name}', i18n('Provider')) }}
            </template>
        </template>

        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2">
            <div class="col-12">
                <Field v-model="formData.identifier" :errorMessage="errorMessages.identifier"
                    :label="i18n('Identifier')" :disabled="submitted || !!provider" :required="true"
                    :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.name" :errorMessage="errorMessages.name" :label="i18n('Name')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="submit" class="btn btn-primary text-white" :disabled="submitted">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import api from "@/api.js";
import { duplicate, } from "@/tools/object.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            providerId: null,
            provider: null,
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    emits: [
        'shown',
        'hidden',
        'created',
        'updated',
    ],
    computed: {
        readonly() {
            return this.provider
                && this.provider.acl?.update !== true;
        },
    },
    methods: {
        show(providerId) {
            this.providerId = providerId;
            this.provider = null;
            this.load().then(() => {
                this.submitted = false;
                this.$refs['modal'].show();
                this.errorMessages = {};
                this.errorMessage = '';

                if (this.provider) {
                    this.formData = duplicate(this.provider);
                } else {
                    this.formData = {};
                }
            });
        },
        load() {
            if (!this.providerId) return Promise.resolve();
            let promise = api.get(`providers/${this.providerId}`, { acl: 'provider' });

            promise.then(provider => {
                this.provider = provider;
            });

            return promise;
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessages = {};
            this.errorMessage = '';

            const postFormData = duplicate(this.formData);
            let savePromise;

            if (!this.provider) {
                savePromise = api.post(`providers`, postFormData);
            } else {
                savePromise = api.put(`providers/${this.provider.id}`, postFormData);
            }

            savePromise.then(provider => {
                if (!this.provider) {
                    this.$emit('created', provider);
                } else {
                    this.$emit('updated', provider);
                }

                api.clearCache();
                this.hide();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        }
    }
}
</script>